import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { CurrencyInputField } from '@mews-commander/form';
import { Stack } from '@optimus-web/core';
import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useCurrencyFormat } from '../../../../../core/globalization/hooks/useCurrencyFormat';

interface BalanceFilterProps {
    balanceMin: string;
    balanceMax: string;
}
export const BalanceFilter = ({ balanceMin, balanceMax }: BalanceFilterProps) => {
    const { defaultCurrencyCode } = useCurrentEnterprise();
    // eslint-disable-next-line @mews/no-restricted-syntax
    const { setValue, setError, watch, clearErrors } = useFormContext();
    const currencyFormat = useCurrencyFormat(defaultCurrencyCode);
    const localizeText = useLocalizeText();
    const errorMessage = localizeText({ textKey: TextKey.RestrictionMaxLessThanMinErrorMessage });

    useEffect(() => {
        const { unsubscribe } = watch((value) => {
            if ((value.balanceMax || value.balanceMax === 0) && value.balanceMax < value.balanceMin) {
                setError(balanceMax, {
                    type: 'manual',
                    message: errorMessage,
                });
            } else {
                clearErrors(balanceMax);
            }
        });
        return () => unsubscribe();
    }, [errorMessage, setError, watch, clearErrors, balanceMax]);

    return (
        <Stack spacing="200" distribution="stretch" data-test-id="balance-filter">
            <CurrencyInputField
                name={balanceMin}
                label={lt('LedgerFilterBalanceMinTitle')}
                onChange={(_, value) => {
                    if (!value && value !== 0) {
                        setValue(balanceMin, '');
                    }
                }}
                fixedDecimalScale
                {...currencyFormat}
                precision={2}
                data-test-id="balanceFilterMin"
            />
            <CurrencyInputField
                name={balanceMax}
                label={lt('LedgerFilterBalanceMaxTitle')}
                onChange={(_, value) => {
                    if (!value && value !== 0) {
                        setValue(balanceMax, '');
                    }
                }}
                fixedDecimalScale
                {...currencyFormat}
                precision={2}
                data-test-id="balanceFilterMax"
            />
        </Stack>
    );
};
